// extracted by mini-css-extract-plugin
export var menuIcon = "_o3-0";
export var menuIconInline = "_o3-1";